module.exports = __webpack_public_path__ + "static/media/Icons-3.51278daf.svg";